import { PageController } from '@client/components/_core/layout/PageController';
import { Tabs } from '@client/components/_core/navigation/Tabs';
import { createFileRoute } from '@tanstack/react-router';
import { Settings2 } from 'lucide-react';

export const Route = createFileRoute('/console/$orgId/configuration/compliance/incidents/general')({
    staticData: {
        metadata: {
            title: 'General',
        },
        ui: {
            icon: Settings2,
            title: 'Incident settings',
            useTitleForChildren: true,
            subtitle: 'Types, causes, impacts, timeline and lodgement form configuration',
            menuDescription: 'Types, causes, impacts, timeline and lodgement form configuration',
        },
    },
    component: RouteComponent,
});

function RouteComponent() {
    return (
        <PageController route={Route}>
            <IncidentGeneralTabs />
        </PageController>
    );
}

function IncidentGeneralTabs() {
    return (
        <Tabs
            items={[
                {
                    label: 'Incident details',
                    to: '/console/$orgId/configuration/compliance/incidents/general/incident-details',
                },
                {
                    label: 'Rectification',
                    to: '/console/$orgId/configuration/compliance/incidents/general/rectification',
                },
                {
                    label: 'Timeline',
                    to: '/console/$orgId/configuration/compliance/incidents/general/timeline',
                },
                {
                    label: 'Lodgement form',
                    to: '/console/$orgId/configuration/compliance/incidents/general/lodgement',
                },
            ]}
        />
    );
}
